import React, { useState } from 'react';
import type { AdminLoginSectionProps, AdminLoginFormData } from '../../types/admin';

const AdminLoginSection: React.FC<AdminLoginSectionProps> = ({ onSubmit, className = '' }) => {
  const [formData, setFormData] = useState<AdminLoginFormData>({
    username: '',
    password: ''
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={`admin-section admin-login-section ${className}`}>
      <div className="admin-access-badge">ADMIN ACCESS</div>
      <h2 className="admin-section-title">Access Portal</h2>
      
      <form className="admin-section-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="username"
          placeholder="Username"
          value={formData.username}
          onChange={handleInputChange}
          className="admin-section-input"
          required
        />
        
        <div className="admin-password-container">
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleInputChange}
            className="admin-section-input"
            required
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="admin-password-toggle"
          >
            {showPassword ? '👁️' : '👁️‍🗨️'}
          </button>
        </div>
        
        <button 
          type="submit" 
          className="admin-section-button admin-button-gradient"
        >
          LOGIN
        </button>
      </form>
    </div>
  );
};

export default AdminLoginSection;